export default function guest ({ next }) {
  if (localStorage.getItem('access_token')) {
    return next({ name: 'home' })
  }
  return next()
}
